import Withdraw from '../ui/Withdraw'
import { connect } from 'react-redux'
import { goBack } from '../../actions'

const mapStateToProps = (state, props) => 
  ({
    page: state.page,
    intl: props.intl,
    user: state.user,
    content: state.content
  })

const mapDispatchToProps = dispatch =>
  ({
    onGoBack(payload) {
       dispatch(
         goBack(payload)
       )
    }
  })

const Container = connect(mapStateToProps, mapDispatchToProps)(Withdraw)

export default Container